import Button from '@/features/shared/Button';
import { MuiBreadcrumbs, MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo } from 'react';
import { BreadcrumbProps } from './Breadcrumb.interface';
import useStyles from './Breadcrumb.styles';

const Breadcrumb = ({ items, separator = '|' }: BreadcrumbProps) => {
  const classes = useStyles({});
  const linksClassName = clsx(classes.links);

  return (
    <MuiBreadcrumbs
      // eslint-disable-next-line react/no-danger
      separator={<span dangerouslySetInnerHTML={{ __html: separator }} />}
      aria-label="breadcrumb"
      className={linksClassName}
      data-testid="breadcrumb--container"
    >
      {items
        ?.filter(({ link }) => Boolean(link))
        .map(({ title, link }) => (
          <Button
            key={link?.href}
            variant="link"
            link={link}
            data-datalayer-ignore-cta="breadcrumb"
          >
            <MuiTypography variant="body1" color="inherit">
              {title}
            </MuiTypography>
          </Button>
        ))}
    </MuiBreadcrumbs>
  );
};

export default memo(Breadcrumb);
